import { useState } from "react";
import { useDispatch } from "react-redux";

import { CreateEmptyPageModule } from "../../../../../../connection/page-modules";
import { addSessionPageModule, updatePageModule } from "../../../../../../store/actions/admin/create-event/session";
import { useTypedSelector } from "../../../../../../store/reducers/use-typed-selector";
import { PageModule } from "../../../../../../types/working-model";
import CustomHTML from "../../../../../general-ui/edit-html/edit-html";
import ModalComponent from "../../../../../general-ui/modal/modal";
import WaitingIndicator from "../../../../../general-ui/waiting-indicator/waiting-indicator";
import CustomOptions from "../../../session/navigation/custom-options/custom-options";
import SessionModuleGroupingList from './session-module-grouping-list';

const SessionLayout: React.FC = () => {
	const {
		AuthReducer: { token },
		CreateSessionReducer: {
			workingSession,
		}
	} = useTypedSelector(state => state);

	const [addModuleOpen, setAddModuleOpen] = useState(false);
	const [blankModalOpen, setBlankModalOpen] = useState(false);
	const [workingBlankModule, setWorkingBlankModule] = useState<PageModule | null>(null);

	const dispatch = useDispatch();

	// function addModule() {
	// 	setAddModuleOpen(true);
	// }

	function closeBlankModule() {
		setBlankModalOpen(false);
	}

	function updateWorkingBlankModule(code: string) {
		setWorkingBlankModule((module: PageModule | null) => {
			if (!module) { return null; }
			return {
				...module,
				content: {
					html: code,
				},
			};
		});
	}

	async function finishedEditingBlank() {
		if (workingBlankModule) {
			if (workingBlankModule.id) {
				dispatch(updatePageModule(workingBlankModule));
			} else {
				const newModule = await CreateEmptyPageModule(token!, workingBlankModule);
				dispatch(addSessionPageModule(newModule));
			}
		}

		closeBlankModule();
	}

	if (!workingSession) return <WaitingIndicator />;
	return (
		<>
			<SessionModuleGroupingList />

			<CustomOptions
				addModuleOpen={addModuleOpen}
				blankModalOpen={blankModalOpen}
				setAddModuleOpen={setAddModuleOpen}
				setBlankModalOpen={setBlankModalOpen}
			/>
			<ModalComponent
				cancellable={true}
				closeable={false}
				open={blankModalOpen}
				onRequestClose={closeBlankModule}
				title={"Blank Module"}
				footer={
					<>
						<button onClick={closeBlankModule} style={{ marginRight: 16 }}>
							Cancel
						</button>
						<button onClick={finishedEditingBlank} className="primary">
							Done
						</button>
					</>
				}
			>
				<div>
					<label className="subtitle">Add custom HTML Code</label>

					<CustomHTML
						defaultValue={workingBlankModule?.content.html ?? ""}
						onChange={updateWorkingBlankModule}
					/>
				</div>
			</ModalComponent>
		</>
	);
};

export default SessionLayout;
